import type { HighlightRun } from "@/lib/fuzzy";

export function HighlightedText({
	runs,
	highlightStyle = "text",
}: {
	runs: HighlightRun[];
	highlightStyle?: "text" | "background";
}) {
	return (
		<>
			{runs.map((run, i) => (
				<span
					key={i}
					style={
						run.matched
							? highlightStyle === "background"
								? { backgroundColor: "var(--search-match-bg)" }
								: { color: "var(--search-match-fg)", fontWeight: 500 }
							: undefined
					}
				>
					{run.text}
				</span>
			))}
		</>
	);
}
